import { render, staticRenderFns } from "./PlanningTableEmpty.vue?vue&type=template&id=88af160c&scoped=true&lang=pug&"
import script from "./PlanningTableEmpty.vue?vue&type=script&lang=js&"
export * from "./PlanningTableEmpty.vue?vue&type=script&lang=js&"
import style0 from "./PlanningTableEmpty.vue?vue&type=style&index=0&id=88af160c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88af160c",
  null
  
)

export default component.exports